import { faSquarePen, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useTable } from 'react-table'
import { FormatMoney } from '../../Utils/functions'
import { Formatter } from 'Utils/Formatter'
import { VAPermissions } from 'Utils/constants'
import PrecioProducto from '../PrecioProducto'
import './singleProductCart.css'
import { QuantityColumn } from './components/QuantityColumn'
import { useTableData } from './hooks/useTableData'
import { removeFromCart } from 'redux/actions/cartActions'
import useValidatePermission from 'Hooks/useValidatePermission'
import GenericModal from 'Components/GenericModal'
import { t } from 'i18next'
import { useHasProductWithPriceUnderCost } from 'Components/CartProduct/hooks/useHasProductWithPriceUnderCost'
import CostMarginVisibility from 'Components/CostMarginVisibility/CostMarginVisibility'
import { getProductDisplayText } from 'Utils/getProductDisplayText'
function SingleProductCart() {
  const productsRef = useRef(null)
  const dispatch = useDispatch()
  const { hasPriceUnderCost, isCommercialSeller } =
    useHasProductWithPriceUnderCost()
  const { columns } = useTableData()
  const isCustomerUser = useSelector(state => state.login.isCustomer)
  const cart = useSelector(state => state.cart.cart)
  const products = useSelector(state => state.cart.cart)
  const [showModalPrecio, setShowModalPrecio] = useState(false)
  const [productSelected, setProductSelected] = useState({})

  const seeMargenProd = useValidatePermission(VAPermissions.seeMargenProd)
  const canChangePrice = useValidatePermission(VAPermissions.priceOverrideAutho)
  const seeCostProd = useValidatePermission(VAPermissions.seeCostProd)

  const rightBorderTable = () => {
    if (seeCostProd && seeMargenProd) {
      return 7
    } else if (
      (!seeCostProd && seeMargenProd) ||
      (seeCostProd && !seeMargenProd)
    ) {
      return 6
    } else {
      return 5
    }
  }

  const formatData = products?.map(product => {
    return {
      ...product,
      codigo: product?.Sku,
      descripcion: getProductDisplayText(product),
      cantidad: parseFloat(product?.Quantity)
        ? parseFloat(product?.Quantity)
        : 1,
      precio: product?.FinalPrice || product?.precio,
      margen: product?.Margin ? product?.Margin.toFixed(2) : 0,
      total:
        product.Price * product.Quantity - (product.VisitDiscountAmount ?? 0),
      editable: !product.IsExtendedWarranty,
    }
  })

  const [showModalSuccessUpdatePrecio, setShowModalSuccessUpdatePrecio] =
    useState(false)

  const tableInstance = useTable({ columns, data: formatData })

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    footerGroups,
  } = tableInstance

  const handleModalEditPrice = product => {
    setShowModalPrecio(!showModalPrecio)
    if (product !== undefined) {
      setProductSelected(product)
    }
  }
  const removeToCart = product => {
    dispatch(removeFromCart({ product }))
  }
  const setProductChangeValidation = value => {
    const index = cart.findIndex(
      item => item.ProductId === productSelected.ProductId
    )
    dispatch({
      type: 'IS_PRICE_CHANGED',
      payload: { index, value },
    })
  }

  const handleModalSuccessUpdatePrecio = () => {
    if (showModalSuccessUpdatePrecio === false) {
      setShowModalSuccessUpdatePrecio(true)
      setTimeout(() => {
        setShowModalSuccessUpdatePrecio(false)
      }, 5000)
    } else {
      setShowModalSuccessUpdatePrecio(false)
    }
  }

  return (
    <div
      className="tableContainer-sp resume"
      data-testid="container-single-product-cart">
      <table
        className="single-product-cart inventory-table products"
        {...getTableProps()}
        data-testid="table-products-cart">
        <thead data-testid="table-head-products-cart">
          {headerGroups.map((headerGroup, i) => (
            <tr
              key={i}
              {...headerGroup.getHeaderGroupProps()}
              data-testid={`table-header-row-${i}`}>
              {headerGroup.headers.map((column, i) => (
                <th
                  key={i}
                  {...column.getHeaderProps()}
                  data-testid={`table-header-${column.Header}`}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} data-testid="table-body-products-cart">
          {rows.map((row, i) => {
            prepareRow(row)
            return (
              <tr
                key={i}
                {...row.getRowProps()}
                ref={productsRef}
                data-testid={`table-row-product-${row.original.ProductId}`}>
                {row.cells.map(cell => {
                  return cell.column.Header === 'Acciones' ? (
                    <td
                      key={cell.value}
                      {...cell.getCellProps()}
                      data-testid={`table-cell-actions-${row.original.ProductId}`}>
                      <FontAwesomeIcon
                        style={{ color: '#F64E60', fontSize: '2rem' }}
                        icon={faTrashCan}
                        onClick={() => {
                          removeToCart(cell.row.original)
                        }}
                        data-testid={`btn-remove-product-${row.original.ProductId}`}
                      />
                    </td>
                  ) : cell.column.Header === 'Total' ? (
                    <td
                      {...cell.getCellProps()}
                      data-testid={`table-cell-total-${row.original.ProductId}`}>
                      ${FormatMoney(cell.value, true, 2)}
                    </td>
                  ) : cell.column.Header === 'Costo' ? (
                    <td
                      {...cell.getCellProps()}
                      data-testid={`table-cell-cost-${row.original.ProductId}`}>
                      ${FormatMoney(cell.row.original.Cost)}
                    </td>
                  ) : cell.column.Header === 'Cantidad' ? (
                    <td
                      {...cell.getCellProps()}
                      data-testid={`table-cell-quantity-${row.original.ProductId}`}>
                      <QuantityColumn cell={cell.row.original} />
                    </td>
                  ) : cell.column.Header === 'Margen' ? (
                    <td
                      {...cell.getCellProps()}
                      data-testid={`table-cell-margin-${row.original.ProductId}`}>
                      {seeMargenProd && (
                        <CostMarginVisibility
                          seeMargenProd={seeMargenProd}
                          simple
                          isMargin
                          margin={cell.value}
                        />
                      )}
                    </td>
                  ) : cell.column.Header === 'Precio' ? (
                    <td
                      {...cell.getCellProps()}
                      data-testid={`table-cell-price-${row.original.ProductId}`}>
                      {cell?.row?.original?.Price !==
                        cell?.row?.original?.FinalPrice ||
                      cell?.row?.original?.VisitDiscountAmount ? (
                        <p
                          style={{
                            textDecoration: 'line-through',
                            color:
                              cell?.row?.original?.Price ===
                              cell?.row?.original?.FinalPrice
                                ? undefined
                                : 'orange',
                          }}
                          data-testid={`text-original-price-${row.original.ProductId}`}>
                          ${cell?.row?.original?.FinalPrice.toFixed(2)}
                        </p>
                      ) : null}
                      {cell?.row?.original?.VisitDiscountAmount
                        ? `$${Formatter.Money(
                            cell?.row?.original?.Price -
                              cell?.row?.original?.VisitDiscountAmount /
                                cell?.row?.original?.Quantity
                          )}`
                        : `$${FormatMoney(cell?.row?.original?.Price)}`}
                      {!isCustomerUser && row.original.editable && (
                        <FontAwesomeIcon
                          icon={faSquarePen}
                          style={{ fontSize: '18px' }}
                          onClick={() =>
                            handleModalEditPrice(cell.row.original)
                          }
                          data-testid={`btn-edit-price-${row.original.ProductId}`}
                        />
                      )}
                    </td>
                  ) : (
                    <td
                      {...cell.getCellProps()}
                      data-testid={`table-cell-${cell.column.Header}-${row.original.ProductId}`}>
                      {cell.render('Cell')}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
        <tfoot data-testid="table-footer-products-cart">
          {footerGroups.map((group, i) => (
            <tr
              key={i}
              {...group.getFooterGroupProps()}
              data-testid={`table-footer-row-${i}`}>
              {group.headers.map((column, index) => (
                <td
                  key={index}
                  style={{
                    border: 'none',
                    borderLeft: index !== 0 && 'none',
                    borderRight: index !== rightBorderTable() && 'none',
                  }}
                  {...column.getFooterProps()}
                  data-testid={`table-footer-cell-${index}`}>
                  {column.render('Footer')}
                </td>
              ))}
            </tr>
          ))}
        </tfoot>
      </table>

      <Modal
        show={showModalPrecio}
        backdrop="static"
        className="modal-precio-producto"
        centered
        data-testid="modal-edit-price">
        <PrecioProducto
          handleModalEditPrice={handleModalEditPrice}
          handleModalSuccesUpdatePrecio={handleModalSuccessUpdatePrecio}
          product={productSelected}
          setNuevoPrecio={() => null}
          setProductChangeValidation={setProductChangeValidation}
        />
      </Modal>

      <Modal
        show={showModalSuccessUpdatePrecio}
        container={productsRef.current}
        backdrop="static"
        centered
        data-testid="modal-price-update-success">
        <GenericModal
          setIsOpen={handleModalSuccessUpdatePrecio}
          text={
            !canChangePrice
              ? t('GENERIC_MODAL.REQUEST_PENDT_APPROVE')
              : hasPriceUnderCost && isCommercialSeller
              ? t('GENERIC_MODAL.REQUEST_PENDT_APPROVE')
              : t('GENERIC_MODAL.PRICE_SUCCESS_CHANGED')
          }
          mostrarButtons={false}></GenericModal>
      </Modal>
    </div>
  )
}

export default SingleProductCart
